import React from 'react';
import { Graphic, PrimaryButton } from '@workday/canvas-kit-react';
import styles from './AddTrustDevice.module.scss';
import { SecondaryButton } from '@workday/canvas-kit-react/button';
import { emptyStateSecurityGraphic } from '@workday/canvas-graphics-web';
import {
    autoId,
    ID_TRUSTED_DEVICE_PAGE,
    ID_TRUSTED_DEVICE_BUTTON,
    ID_TRUSTED_DEVICE_NO_THANKS_BUTTON
} from '@workday/upc-common';
import classNames from 'classnames';

export interface AddTrustDeviceProps {
    onSubmit: () => void;
    onSkip: () => void;
    subtitle: string;
    title: string;
    submitText: string;
    skipText: string;
    disabled?: boolean;
    className?: string;
}

export const AddTrustDevice = ({
    onSubmit,
    onSkip,
    subtitle,
    title,
    submitText,
    skipText,
    className,
    disabled = false
}: AddTrustDeviceProps) => {
    return (
        <div className={classNames(styles.addTrustDevice, className)} {...autoId(ID_TRUSTED_DEVICE_PAGE)}>
            <div className={styles.logo}>
                <Graphic src={emptyStateSecurityGraphic} />
            </div>
            <h1 className={styles.title}>{title}</h1>
            <h2 className={styles.subtitle}>{subtitle}</h2>
            <PrimaryButton
                {...autoId(ID_TRUSTED_DEVICE_BUTTON)}
                id={ID_TRUSTED_DEVICE_BUTTON}
                className={styles.submitButton}
                size='medium'
                grow={true}
                disabled={disabled}
                type='button'
                onClick={onSubmit}>
                {submitText}
            </PrimaryButton>
            <SecondaryButton
                {...autoId(ID_TRUSTED_DEVICE_NO_THANKS_BUTTON)}
                id={ID_TRUSTED_DEVICE_NO_THANKS_BUTTON}
                type='button'
                className={styles.noThanksButton}
                size='medium'
                grow={true}
                disabled={disabled}
                onClick={onSkip}>
                {skipText}
            </SecondaryButton>
        </div>
    );
};
